export function getSingletonEntry<T>(
  items: readonly T[],
  entryName: string,
): T {
  const [entry, ...rest] = items

  if (rest.length > 0) {
    throw new Error(`Multiple ${entryName} entries found`)
  }

  if (entry == null) {
    throw new Error(`No ${entryName} entry found`)
  }

  return entry
}
